const tracksValidationES = {
    "trackName": {
        "required": "El nombre de la pista es obligatorio",
        "length": "El nombre de la pista debe tener más de 1 y menos de 255 caracteres",
        "regexp": "El nombre de la pista solo puede consistir en letras, números, espacios y guiones bajos"
    },
    "mix_name": {
        "required": "Por favor, escriba el nombre del mix",
        "regexp": "El nombre del mix solo puede consistir en letras, números, espacios y guiones bajos"
    },
    "artistName": {
        "required": "Por favor, seleccione artista"
    },
    "artistType": {
        "required": "Por favor, seleccione tipo de artista"
    },
    "atleastOneMainArtist": {
        "required": "Al menos un artista debe ser principal"
    },
    "duplicateArtists": {
        "required": "Hay dos o más artistas con el mismo nombre."
    },
    "publisherName": {
        "required": "Por favor, seleccione editor"
    },
    "publisherAuthor": {
        "required": "Por favor, inserte el nombre y apellido real de la persona."
    },
    "contributorName": {
        "required": "Por favor, seleccione colaborador"
    },
    "contributorRole": {
        "required": "Por favor, seleccione el rol del colaborador"
    },
    "atleastOneComposer": {
        "required": "Al menos un colaborador debe ser compositor"
    },
    "atleastOneLyricist": {
        "required": "Al menos un colaborador debe ser letrista"
    },
    "copyright": {
        "required": "El copyright es obligatorio",
        "regexp": "El copyright solo puede consistir en letras, números, espacios y guiones bajos"
    },
    "copyrightYear": {
        "required": "El año de copyright es obligatorio",
        "regexp": "El año de copyright debe ser un año válido"
    },
    "ISRC": {
        "required": "Por favor, proporcione ISRC o marque Generar ISRC",
        "regexp": "Por favor, inserte un código ISRC válido o deje vacío"
    },
    "DA_ISRC": {
        "required": "Por favor, proporcione ISRC de Dolby Atmos o marque Generar ISRC",
        "regexp": "Por favor, inserte un código ISRC válido o deje vacío"
    },
    "trackLanguage": {
        "required": "El idioma de la pista es obligatorio. Por favor, seleccione el idioma del nombre de su pista."
    },
    "trackVocals": {
        "required": "La vocal de la pista es obligatoria. Por favor, seleccione el idioma de sus voces."
    },
    "trackGenre": {
        "required": "Por favor, seleccione el género de su pista."
    },
    "trackSubGenre": {
        "required": "Por favor, seleccione el subgénero de su pista"
    },
    "featuringArtistMissing": {
        "required": "La pista debe tener el artista destacado listado en el título correctamente asignado a un rol de artista destacado. Por favor, corrija y vuelva a enviar."
    }
};

export default tracksValidationES;